import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HideDataIgnoreAttributeUI from './hidedataignoreattributeui';


export default class HideDataIgnoreAttribute extends Plugin {
  static get pluginName() {
    return 'HideDataIgnoreAttribute';
  }

  static get requires() {
    return [ HideDataIgnoreAttributeUI ];
  }
}
